import { Link } from 'react-router-dom';

const MenuHeader = (logo, title) => (
  <Link to="/">
    {logo}
    {title}
  </Link>
);
export default MenuHeader;
